import BaseResource                        from '@/lib/data/resource/BaseResource'
import { collect }                         from '@/lib/utils/array'
import NIIForwardSimulationsAssetResource from '@/api/resources/risks/NIIForwardSimulationsAssetResource'
import NIIAssetNameResource                   from '@/api/resources/asset/NIIAssetNameResource'

export default class NIIForwardSimulationsResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    const selectedPeriod = payload?.selectedPeriod ?? 'risk12mAnalysisData'

    const o = payload[selectedPeriod]?.simulation || null

    this.Assets = collect(o?.components || [], NIIAssetNameResource)
    this.Data = collect(o?.items || [], NIIForwardSimulationsAssetResource)
  }

  /* PROPERTIES */

  /* METHODS */
}
